module.exports = __webpack_public_path__ + "img/cut_gd2.f38d9793.png";